module.exports = __webpack_public_path__ + "svg/sprite.c14e305757e2398ee46b4cf0ba183a18.svg";